import React from 'react'
import { Popper, Fade, ClickAwayListener, ToggleButtonGroup, ToggleButton, IconButton, Box } from '@mui/material'
import { Language, Check } from '@mui/icons-material'
import { onChangeLanguage } from '../actions'
import { useSelector, useDispatch } from 'react-redux'
import { IReducer, LangType } from '../interface'
import { useCookies } from 'react-cookie'
import { PaperDropdown } from 'src/styles'
import ReactGA from 'react-ga4'
import { useNavigate } from 'react-router-dom'

export default function Region() {
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef<HTMLButtonElement>(null)
  const changeLanguage = useSelector((state: IReducer) => state.changeLanguage)
  const [region, setRegion] = React.useState(changeLanguage.lang)
  const dispatch = useDispatch()
  const [, setCookies] = useCookies(['language'])
  const navigate = useNavigate()
  const pathname = window.location.pathname

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
    ReactGA.gtag('event', 'click_language_icon')
  }

  const handleClose = (event: any) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }
    setOpen(false)
  }

  const handleChange = (event: React.MouseEvent<HTMLElement>, newLanguage: LangType) => {
    event.preventDefault()
    if (newLanguage) {
      setRegion(newLanguage)
      const routeWithoutLang = pathname.split('/').slice(2).join('/')
      const isEnglishLang = newLanguage === 'en'
      const newPath = isEnglishLang ? `/${routeWithoutLang}` : `/${newLanguage}${pathname === '/' ? '' : pathname}`
      navigate(newPath, { replace: true })
      dispatch(onChangeLanguage(newLanguage))
      setCookies('language', newLanguage, { path: '/' })
    }
  }

  return (
    <Box id='language-selector'>
      <IconButton
        color='secondary'
        disableTouchRipple
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup='true'
        onClick={handleToggle}
      >
        <Language data-gtm-click-subsection2='Language Icon' />
      </IconButton>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        placement='bottom-end'
        sx={{ zIndex: 9 }}
      >
        {({ TransitionProps, placement }) => (
          <Fade {...TransitionProps} style={{ transformOrigin: placement }}>
            <PaperDropdown>
              <ClickAwayListener onClickAway={handleClose}>
                <ToggleButtonGroup
                  orientation='vertical'
                  value={region}
                  exclusive
                  onClick={handleClose}
                  onChange={handleChange}
                  aria-label='Platform'
                  sx={{ py: 0 }}
                  fullWidth
                >
                  {changeLanguage.availableLanguages.map((value, index) => (
                    <ToggleButton
                      id='language-button'
                      value={value.key}
                      disableRipple
                      key={index}
                      className='nav-dropdown'
                      sx={{ textTransform: 'capitalize' }}
                      data-gtm-click-subsection2='Language Icon'
                    >
                      <Check
                        color='primary'
                        sx={{ mr: 1.5, ml: -0.5, width: 16, opacity: region === value.key ? 1 : 0 }}
                      />
                      {value.text}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              </ClickAwayListener>
            </PaperDropdown>
          </Fade>
        )}
      </Popper>
    </Box>
  )
}
